import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import * as api from './apis/signup';
import { setTokens } from './setTokens';
import { emit, triggerError } from '../utils/eventManager';
import { sendNewRelicEvent } from '../utils/newRelicEvents';
import { MfaRequiredError } from '../utils/GqlError';
export { signup };
function signup(_x, _x2, _x3) {
  return _signup.apply(this, arguments);
}
function _signup() {
  _signup = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(creds, profile, client) {
    var signUpResponse, tokens, encryptedEmail, encryptedCheggId, idToken, accessToken;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          sendNewRelicEvent({
            EventName: 'signup_start'
          });
          _context.next = 4;
          return api.signup(creds, profile, client);
        case 4:
          signUpResponse = _context.sent;
          tokens = signUpResponse.tokens, encryptedEmail = signUpResponse.encryptedEmail, encryptedCheggId = signUpResponse.encryptedCheggId;
          idToken = tokens.idToken, accessToken = tokens.accessToken;
          sendNewRelicEvent({
            EventName: 'signup_success'
          });
          emit('signup.success', {
            tokens: tokens,
            encryptedEmail: encryptedEmail,
            encryptedCheggId: encryptedCheggId
          });
          _context.next = 11;
          return setTokens({
            idToken: idToken,
            accessToken: accessToken,
            callInitSession: true,
            broadcast: true,
            authActionType: 'signup'
          });
        case 11:
          return _context.abrupt("return", signUpResponse);
        case 14:
          _context.prev = 14;
          _context.t0 = _context["catch"](0);
          if (!(_context.t0 instanceof MfaRequiredError)) {
            _context.next = 18;
            break;
          }
          throw _context.t0;
        case 18:
          sendNewRelicEvent({
            EventName: 'signup_failed',
            error: _context.t0
          });
          triggerError('signup', _context.t0);
          throw _context.t0;
        case 21:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 14]]);
  }));
  return _signup.apply(this, arguments);
}